import { TToggleStore } from 'store/common/toggle/types';

type TWaffleItem = {
  is_active: boolean;
  last_modified: string;
};

export enum EWaffleSwitches {
  csi = 'csi',
  rating = 'rating',
  rebiddingDrawer = 'rebiddingDrawer',
  ym = 'ym',
  denyAnonymous = 'denyAnonymous',
  lotProposalsAnalysis = 'lotProposalsAnalysis',
  hideChat = 'hideChat',
  hideRegistrationButton = 'hideRegistrationButton',
  hideTelegramAlert = 'hideTelegramAlert',
  allPrices = 'allPrices',
  approvers = 'approvers',
  hideContract = 'hideContract',
  additionalCompanyFields = 'additionalCompanyFields',

  notifications = 'notifications',

  newAccreditationTab = 'newAccreditationTab',

  newYearTheme = 'newYearTheme',

  tenderCommitee = 'tenderCommitee',
  hideCreateCommitteeWithoutTemplate = 'hideCreateCommitteeWithoutTemplate',

  newHeader = 'newHeader',

  isAIDisabled = 'isAIDisabled',

  showGetBestPrices = 'showGetBestPrices',

  spark = 'spark',
}

export type TWaffle = {
  flags: Record<string, TWaffleItem>;
  switches: Record<EWaffleSwitches, TWaffleItem>;
  samples: Record<string, TWaffleItem>;
};

export const featuresMap: Record<EWaffleSwitches, keyof TToggleStore> = {
  csi: 'csi',
  rating: 'rating',
  rebiddingDrawer: 'rebiddingDrawer',
  ym: 'ym',
  denyAnonymous: 'denyAnonymous',
  lotProposalsAnalysis: 'lotProposalsAnalysis',
  hideChat: 'hideChat',
  hideRegistrationButton: 'hideRegistrationButton',
  hideTelegramAlert: 'hideTelegramAlert',
  allPrices: 'allPrices',
  approvers: 'approvers',
  hideContract: 'hideContract',
  additionalCompanyFields: 'additionalCompanyFields',
  showGetBestPrices: 'showGetBestPrices',
  newAccreditationTab: 'newAccreditationTab',
  newYearTheme: 'newYearTheme',
  notifications: 'notifications',
  spark: 'spark',
  tenderCommitee: 'tenderCommitee',
  hideCreateCommitteeWithoutTemplate: 'hideCreateCommitteeWithoutTemplate',
  newHeader: 'newHeader',
  isAIDisabled: 'isAIDisabled',
};
